export default {
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },
    updateCustomer(state, payload) {
        state.Customer = payload;
    },
    updateCustomers(state, payload) {
        state.Customers = payload;
    }
}